import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getSystemUsersQueryOptions } from '@/_pages/system-users/api-service';

export const Route = createFileRoute('/_private/system-users/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true },
  loader: (opts) => opts.context.queryClient.ensureQueryData(getSystemUsersQueryOptions()),
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={5} numberOfButtons={0} />,
});
